/**
 * Replaces the browser URL without triggering a React rerender.
 *
 * Use this instead of `routerActions.replace` when preserving the current render is important.
 *
 * @param url - The target URL to write into browser history.
 */
export const replaceUrlWithoutRerender = (url: string): void =>
    window.history.replaceState(null, '', url);
